import { useState, type FormEvent } from 'react'

import { api, ErrorApi, type Categoria, type Cliente } from '../api'

export interface Borrador {
  nombre?: string
  telefono?: string
  correo?: string
  origen: 'panel' | 'web' | 'whatsapp'
  origen_id?: string
}

interface Props {
  borrador: Borrador
  alCerrar: () => void
  alCrear: (c: Cliente) => void
  /** Ya habia un cliente con esa cedula/RUC o ese lead: se abre el existente. */
  alExistir: (id: string) => void
}

export function NuevoCliente({ borrador, alCerrar, alCrear, alExistir }: Props) {
  const [nombre, setNombre] = useState(borrador.nombre ?? '')
  const [identificacion, setIdentificacion] = useState('')
  const [telefono, setTelefono] = useState(borrador.telefono ?? '')
  const [correo, setCorreo] = useState(borrador.correo ?? '')
  const [categoria, setCategoria] = useState<Categoria>('residencial')
  const [error, setError] = useState('')
  const [existente, setExistente] = useState<string | null>(null)
  const [enviando, setEnviando] = useState(false)

  const esLead = borrador.origen !== 'panel'

  const enviar = async (e: FormEvent) => {
    e.preventDefault()
    setError('')
    setExistente(null)
    setEnviando(true)
    try {
      const { cliente } = await api.crearCliente({
        nombre,
        identificacion,
        telefono,
        correo,
        categoria,
        origen: borrador.origen,
        origen_id: borrador.origen_id,
      })
      alCrear(cliente)
    } catch (err) {
      if (err instanceof ErrorApi) {
        setError(err.message)
        if (err.estado === 409 && typeof err.datos.clienteId === 'string') setExistente(err.datos.clienteId)
      } else {
        setError('No se pudo guardar.')
      }
    } finally {
      setEnviando(false)
    }
  }

  return (
    <div className="velo" onClick={alCerrar}>
      <form className="tarjeta dialogo" onSubmit={enviar} onClick={(e) => e.stopPropagation()}>
        <h2>{esLead ? 'Convertir lead en cliente' : 'Nuevo cliente'}</h2>
        {esLead && (
          <p className="suave">
            Viene {borrador.origen === 'web' ? 'del formulario web' : 'de WhatsApp'}. La cédula o RUC es opcional: puedes
            agregarla después desde su ficha.
          </p>
        )}

        <label>
          Nombre o razón social
          <input value={nombre} onChange={(e) => setNombre(e.target.value)} required />
        </label>
        <div className="fila">
          <label>
            Cédula o RUC (opcional)
            <input
              value={identificacion}
              onChange={(e) => setIdentificacion(e.target.value)}
              inputMode="numeric"
              placeholder="Déjala vacía si no te la dan"
            />
          </label>
          <label>
            Tipo de cliente
            <select value={categoria} onChange={(e) => setCategoria(e.target.value as Categoria)}>
              <option value="residencial">Residencial</option>
              <option value="comercial">Comercial</option>
              <option value="industrial">Industrial</option>
            </select>
          </label>
        </div>
        <div className="fila">
          <label>
            Teléfono
            <input value={telefono} onChange={(e) => setTelefono(e.target.value)} inputMode="tel" />
          </label>
          <label>
            Correo
            <input type="email" value={correo} onChange={(e) => setCorreo(e.target.value)} />
          </label>
        </div>

        {error && (
          <p className="error">
            {error}{' '}
            {existente && (
              <button type="button" className="enlace" onClick={() => alExistir(existente)}>
                Abrir el existente
              </button>
            )}
          </p>
        )}

        <div className="botones">
          <button type="button" className="secundario" onClick={alCerrar}>
            Cancelar
          </button>
          <button className="primario" disabled={enviando}>
            {enviando ? 'Guardando…' : 'Guardar cliente'}
          </button>
        </div>
      </form>
    </div>
  )
}
